import { apiGetRequest } from "helpers/Requests";
import { URL_CUSTOM_LINE_ITEMS } from "store/services/URL";

const cache = new Map();
const inFlight = new Map();

export function buildCustomLineItemsSelectOptionsUrl({
  participantId,
  fundingTypes = [],
  filterByFundingType = false,
  includeUuid = null,
  invoiceServiceTypeId = null,
  sta = false,
  shiftDate = null,
}) {
  let url = `${URL_CUSTOM_LINE_ITEMS}/select-options?status=active&per_page=1000`;
  if (filterByFundingType && fundingTypes.length > 0) {
    url += `&funding_types=${encodeURIComponent(fundingTypes.join(","))}`;
  }
  if (participantId) {
    url += `&participant_id=${participantId}`;
  }
  // Scope to the split/main service category so basic create gets the right rows.
  if (invoiceServiceTypeId != null && invoiceServiceTypeId !== "") {
    url += `&invoice_service_type_id=${encodeURIComponent(
      invoiceServiceTypeId
    )}`;
  }
  // Keep a line item already saved on the roster even if it falls outside
  // the current shift-screen funding visibility filter (or is inactive).
  if (includeUuid) {
    url += `&include_uuid=${encodeURIComponent(includeUuid)}`;
  }
  // Multi-funding + STA: ask select-options for Price Catalogue STA items too.
  if (sta) {
    url += `&sta=true`;
    if (shiftDate) {
      url += `&shift_date=${encodeURIComponent(shiftDate)}`;
    }
  }
  return url;
}

/**
 * @returns {Promise<{ items: Array, staItems: Array }>}
 */
export function fetchCustomLineItemsSelectOptions(url) {
  if (cache.has(url)) {
    return Promise.resolve(cache.get(url));
  }
  if (inFlight.has(url)) {
    return inFlight.get(url);
  }

  const promise = apiGetRequest(url)
    .then((res) => {
      const raw = res?.data?.data ?? res?.data ?? [];
      const items = Array.isArray(raw) ? raw : [];
      const staItems = Array.isArray(res?.data?.sta_items)
        ? res.data.sta_items
        : [];
      const payload = { items, staItems };
      cache.set(url, payload);
      inFlight.delete(url);
      return payload;
    })
    .catch((err) => {
      inFlight.delete(url);
      throw err;
    });

  inFlight.set(url, promise);
  return promise;
}

export function clearCustomLineItemsSelectOptionsCache() {
  cache.clear();
  inFlight.clear();
}
